module.exports = __webpack_public_path__ + "img/tof_no.ab359310.png";